export const MIN_SPACE_SIZE = 0.999;

export const VISUAL_DRAG_TOLERANCE_CONFIG = {
	MIN_FOR_SHORT_VIDEOS: 0.01,
	MAX_FOR_LONG_VIDEOS: 0.5,
	PERCENTAGE: 0.005,
	SHORT_VIDEO_MINIMUM_TOLERANCE: 10
} as const;

export function getVisualDragTolerance(videoDuration: number): number {
	if (videoDuration <= 0) return 0;

	if (videoDuration < 15) {
		return 0;
	}

	const calculated = videoDuration * VISUAL_DRAG_TOLERANCE_CONFIG.PERCENTAGE;

	return Math.max(
		VISUAL_DRAG_TOLERANCE_CONFIG.MIN_FOR_SHORT_VIDEOS,
		Math.min(VISUAL_DRAG_TOLERANCE_CONFIG.MAX_FOR_LONG_VIDEOS, calculated)
	);
}

export const TIME_FORMAT = {
	SECONDS_PER_HOUR: 3600,
	SECONDS_PER_MINUTE: 60,
	MILLISECONDS_PRECISION: 3,
	TIME_PART_COUNT: 3,
	PADDING_LENGTH: 2,
	PADDING_CHAR: '0' as const,
	DECIMAL_BASE: 10
} as const;

export const POSITION_PROPERTIES = {
	MIN_POSITION: 0,
	MARGIN_MULTIPLIER: 2,
	CENTER_DIVISOR: 2
} as const;

export const DEFAULT_CONFIG = {
	MAX_WIDTH_RATIO: 0.2,
	MARGIN: 12,
	MAJOR_HEIGHT: 24,
	MINOR_HEIGHT: 16,
	CYCLE_BAR_HEIGHT: 24,
	NEEDLE_HANDLE_HEIGHT: 22
} as const;

export const INTERACTION_PROPERTIES = {
	HANDLE_RADIUS: 6,
	HANDLE_THRESHOLD: 12,
	MOVE_THRESHOLD: 8
} as const;

export const CYCLE_EDGE = {
	START: 'start',
	END: 'end'
} as const;

export const CURSOR_TYPES = {
	DEFAULT: 'default',
	POINTER: 'pointer',
	EW_RESIZE: 'ew-resize',
	COL_RESIZE: 'col-resize',
	GRAB: 'grab',
	GRABBING: 'grabbing',
	NOT_ALLOWED: 'not-allowed'
} as const;

export const CANVAS_GEOMETRY = {
	ZERO_COORDINATE: 0,
	FULL_CIRCLE_RADIANS: 2 * Math.PI,
	HALF_DIVISOR: 2
} as const;

export const DEFAULT_TIME_SCALE_CONFIG = {
	MAJOR_HEIGHT: 20,
	MINOR_HEIGHT: 10,
	MARGIN: 50
};

export const DEFAULT_VIDEO_DURATION = 120;

export const TICK_INTERVAL_MULTIPLIERS = [1, 2, 5];
export const TARGET_MAJOR_TICK_SPACING_PX = 80;
export const TARGET_MINOR_TICK_SPACING_PX = 16;
export const FLOATING_POINT_TOLERANCE = 0.0001;

export const TIME_SCALES = [
	{ threshold: 0.001, baseUnit: 0.001, label: 'microseconds' },
	{ threshold: 0.01, baseUnit: 0.001, label: 'milliseconds' },
	{ threshold: 1, baseUnit: 0.01, label: 'centiseconds' },
	{ threshold: 60, baseUnit: 1, label: 'seconds' },
	{ threshold: 3600, baseUnit: 60, label: 'minutes' },
	{ threshold: Infinity, baseUnit: 3600, label: 'hours' }
];

export const TICK_RATIO_ADJUSTMENT = {
	MIN_MAJOR_TICK_COUNT: 2,
	FALLBACK_DIVISOR: 5,
	RATIO_THRESHOLDS: {
		VERY_CLOSE: 2,
		CLOSE: 4,
		MODERATE: 8
	},
	DIVISORS: {
		FOR_VERY_CLOSE_RATIO: 4,
		FOR_CLOSE_RATIO: 5,
		FOR_MODERATE_RATIO: 10
	}
} as const;

export const ONE_MILLISECOND = 0.001;

export const DURATION_TOLERANCE = 0.001;

export const UPDATE_TYPE = {
	SEEK: 'seek',
	CYCLE: 'cycle'
} as const;

export const MOUSE_ACTION_TYPE = {
	CYCLE_DRAG: 'CYCLE_DRAG',
	NEEDLE_SCRUB: 'NEEDLE_SCRUB',
	CYCLE_SELECT: 'CYCLE_SELECT',
	EMPTY_SCRUB: 'EMPTY_SCRUB'
} as const;

export const DRAG_INTERACTIONS = ['start-resize', 'end-resize', 'move'];
